import { useMutation } from "@tanstack/react-query";
import { omit } from "lodash";
import { updateCustomType, updateCustomTypeOrderable } from "PFCore/services/custom_types";
import { CustomType } from "PFTypes/custom_type";
import { MutationOptions } from "PFTypes/request_options";

import { useCustomTypesInvalidate } from "./use_custom_types_invalidate";

export const useCustomTypeUpdate = ({ onSuccess, ...queryParams }: MutationOptions<CustomType>) => {
  const { invalidate } = useCustomTypesInvalidate();

  const updateCustomTypeMutation = useMutation({
    mutationFn: (payload: CustomType): any => updateCustomType(payload.id, omit(payload, "id")),
    onSuccess: (...args) => {
      invalidate(args[0].id);
      onSuccess?.(...args);
    },
    ...queryParams
  });

  const updateOrderableMutation = useMutation({
    mutationFn: (payload: CustomType): any => updateCustomTypeOrderable(payload.id, payload.orderable),
    onSuccess: (...args) => {
      invalidate(args[0].id);
      onSuccess?.(...args);
    },
    ...queryParams
  });

  return {
    updateCustomType: updateCustomTypeMutation,
    updateCustomTypeOrderable: updateOrderableMutation
  };
};
